/*
 * Access gate (Bloque 1 of the account plan, D-1/D-5). No dependencies, no routing of its own beyond the plain link to Shopify's login.
 *   NcAuth.isIn()            the page says so: <body data-nc-auth="in|out"> (layout/theme.liquid). Unknown (no attribute) counts as "in".
 *   NcAuth.loginUrl(path)    '/customer_authentication/login?return_url=<path>' (path is a same-site path + query)
 *   NcAuth.resumeUrl(key)    current page + ?nc-resume=<key> (other nc-resume values dropped), to come back to the same screen
 *   NcAuth.prompt(opts)      opens the access sheet: { resume: 'crear', kind: 'create' | 'save', trigger }
 *   NcAuth.takeResume(key)   true once when the page was opened with ?nc-resume=<key> AND there is a session (the flag leaves the URL)
 * The cancelable `nc-fitting:signin`, `nc-look-detail:signin` and `nc-auth:signin` events of the components open the sheet when nobody
 * called preventDefault.
 */
(function (root) {
  var LOGIN = '/customer_authentication/login';

  function loginUrl(path, base) {
    var p = typeof path === 'string' && path.charAt(0) === '/' && path.charAt(1) !== '/' ? path : '/';
    return (base || LOGIN) + '?return_url=' + encodeURIComponent(p);
  }

  function resumeUrl(key, loc) {
    var l = loc || (root.location || { pathname: '/', search: '' });
    var q = String(l.search || '').replace(/^\?/, '').split('&').filter(function (kv) { return kv && kv.split('=')[0] !== 'nc-resume'; });
    q.push('nc-resume=' + encodeURIComponent(key));
    return (l.pathname || '/') + '?' + q.join('&');
  }

  function isIn(doc) {
    var d = doc || root.document, b = d && d.body;
    return !(b && b.getAttribute('data-nc-auth') === 'out');
  }

  function takeResume(key) {
    var loc = root.location, doc = root.document;
    if (!loc || !doc || !isIn(doc)) return false;
    var m = String(loc.search || '').match(/[?&]nc-resume=([^&]*)/);
    if (!m || decodeURIComponent(m[1]) !== key) return false;
    try {
      var q = loc.search.replace(/^\?/, '').split('&').filter(function (kv) { return kv && kv.split('=')[0] !== 'nc-resume'; });
      root.history.replaceState(null, '', loc.pathname + (q.length ? '?' + q.join('&') : '') + (loc.hash || ''));
    } catch (e) { /* no history API */ }
    return true;
  }

  var api = { loginUrl: loginUrl, resumeUrl: resumeUrl, isIn: isIn, takeResume: takeResume, LOGIN: LOGIN };
  root.NcAuth = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document === 'undefined') return;

  var pending = null;

  function sheetWrap() { return document.querySelector('[data-nc-auth-sheet]'); }

  api.prompt = function (opts) {
    opts = opts || {};
    var wrap = sheetWrap(), sheet = wrap && wrap.querySelector('nc-sheet');
    if (!sheet || typeof sheet.open !== 'function') {
      // sheet not ready (script order): the plain link still works
      root.location.href = loginUrl(opts.resume ? resumeUrl(opts.resume) : root.location.pathname + root.location.search, wrap && wrap.getAttribute('data-login-url'));
      return;
    }
    var save = opts.kind === 'save', account = opts.kind === 'account';
    var title = sheet.querySelector('.nc-sheet__title'), body = sheet.querySelector('[data-nc-auth-body]');
    if (!wrap.hasAttribute('data-default-title')) { wrap.setAttribute('data-default-title', title.textContent); wrap.setAttribute('data-default-body', body.textContent); }
    var which = save ? 'save' : account ? 'account' : 'default';
    title.textContent = wrap.getAttribute('data-' + (which === 'default' ? 'default-title' : 'title-' + which));
    body.textContent = wrap.getAttribute('data-' + (which === 'default' ? 'default-body' : 'body-' + which));
    pending = opts;
    sheet.open(opts.trigger || document.activeElement);
  };

  // every sign-in link of the theme (banner, sidebar, header) comes back to the exact screen, query included (?view=…)
  function retarget() {
    var back = root.location.pathname + root.location.search;
    Array.prototype.forEach.call(document.querySelectorAll('a[href^="' + LOGIN + '"]'), function (a) { a.setAttribute('href', loginUrl(back)); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', retarget); else retarget();

  document.addEventListener('nc-sheet:action', function (e) {
    var wrap = e.target && e.target.closest && e.target.closest('[data-nc-auth-sheet]');
    if (!wrap) return;
    if (e.detail && e.detail.id === 'login') {
      var o = pending || {};
      root.location.href = loginUrl(o.resume ? resumeUrl(o.resume) : root.location.pathname + root.location.search, wrap.getAttribute('data-login-url'));
    }
  });

  // Favourites and likes of a visitor live on this device only (D-1): say so, once per press, with the way to keep them
  document.addEventListener('nc-card:toggle', function (e) {
    if (isIn() || !e.detail || !e.detail.pressed) return;
    var wrap = sheetWrap(), msg = wrap && wrap.getAttribute('data-saved-on-device');
    if (msg && root.NcToast && root.NcToast.show) root.NcToast.show({ tone: 'success', message: msg });
  });

  // screens that are a form (edit profile, upload look): a visitor gets the sheet instead of the form, which stays hidden
  function gateScreens() {
    if (isIn()) return;
    var gate = document.querySelector('[data-nc-auth-gate]');
    if (!gate) return;
    var screen = gate.nextElementSibling;
    if (screen) screen.hidden = true;
    var cta = gate.querySelector('[data-nc-auth-open]');
    if (cta) cta.addEventListener('click', function (e) { e.preventDefault(); api.prompt({ kind: 'account', trigger: cta }); });
    // the sheet element may not be upgraded yet at this point: wait for it instead of falling back to the plain redirect
    var open = function () { api.prompt({ kind: 'account', trigger: cta }); };
    if (root.customElements && root.customElements.whenDefined) root.customElements.whenDefined('nc-sheet').then(open); else open();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', gateScreens); else gateScreens();

  ['nc-fitting:signin', 'nc-look-detail:signin', 'nc-auth:signin'].forEach(function (name) {
    document.addEventListener(name, function (e) {
      var d = e.detail || {};
      // d.expired: the page still says "signed in" but the server answered 401 (session expired), so the sheet opens anyway
      if (e.defaultPrevented || (isIn() && !d.expired)) return;
      api.prompt({ resume: d.resume || (name === 'nc-fitting:signin' && d.reason === 'render' ? 'crear' : ''), kind: d.reason === 'save' ? 'save' : (name === 'nc-fitting:signin' ? 'create' : 'account'), trigger: d.trigger || e.target });
    });
  });
})(typeof window !== 'undefined' ? window : globalThis);
